// Bootstrapのスタイルシート側の機能を読み込む
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/css/bootstrap-reboot.rtl.min.css';
//import 'bootstrap/dist/css/bootstrap-grid.rtl.min.css';

import './sass/style.scss'; //バンドルするCSSの読み込み

//lazyload
import LazyLoad from 'vanilla-lazyload';
const lazyLoadOptions = {
  /* your options here */
};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);

//modal
import MicroModal from 'micromodal';
const modal = document.querySelector('.js-modal-toggle');
//モーダルボタンのaタグ無効化
if (modal) {
  MicroModal.init();
  modal.addEventListener('click', (e) => {
    e.preventDefault();
  });
}

//JSファイルの読み込み
// import './js/smooth';

import './js/swiper-custom';
import './js/mouse';
//import './js/scrollBar';
import './js/anime';

// BootstrapのJavaScript側の機能を読み込む
// import 'bootstrap';

// スマホでヒーローを全画面にする
function setHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
setHeight();
window.addEventListener('resize', setHeight);

//
//変数
const humOpen = document.querySelector('.openbtn');
const body = document.body;
const nav = document.querySelector('.nav');
const navBgLists = document.querySelectorAll('.nav_img_bg__item');
const hero = document.getElementById('hero');
const heroHeight = hero.clientHeight;
const progress = document.querySelector('.progress');
const header = document.querySelector('.header');
const sectionLinks = document.querySelectorAll('.progress_list__link');
const sections = document.querySelectorAll('.section_area');
let set_position = 0;

//ハンバーガーメニュー

function navFunc() {
  body.classList.toggle('active');
  nav.classList.toggle('active');
  humOpen.classList.toggle('active');
}
humOpen.addEventListener('click', navFunc);

//ナビゲーション

//ナビゲーションメニューの背景を入れ替える処理（PCのみ適用）
if (!window.matchMedia('(max-width: 991px)').matches) {
  menuFunc();
}

function menuFunc() {
  //初期化
  document.querySelector('.nav_img_bg__item--1').classList.add('active');

  nav.addEventListener('mousemove', function (e) {
    const clicked = e.target.closest('.nav_main_list__link');

    if (!clicked) return;

    navBgLists.forEach((c) => c.classList.remove('active'));

    document
      .querySelector(`.nav_img_bg__item--${clicked.dataset.nav}`)
      .classList.add('active');
  });
}
//メニューリンクをクリックしたらナビゲーションを閉じる処理
nav.addEventListener('click', function (e) {
  if (e.target.classList.contains('nav_main_list__link')) {
    setTimeout(navFunc, 100);
  }
});

// ヘッダーのスクロール制御

window.addEventListener('scroll', function () {
  if (!nav.classList.contains('active')) {
    if (set_position < document.documentElement.scrollTop) {
      //   console.log(`down`);
      header.classList.add('active');
    } else {
      // console.log(`up`);
      header.classList.remove('active');
    }
  }
  set_position = document.documentElement.scrollTop;
});

// //elevatorリンク
// function elevatorFunc() {
//   window.addEventListener('scroll', function () {
//     if (
//       document.body.scrollTop > heroHeight ||
//       document.documentElement.scrollTop > heroHeight
//     ) {
//       progress.classList.add('active');
//     } else {
//       progress.classList.remove('active');
//     }

//     // sectionLinks.forEach((link, index) => {
//     //   //document要素の絶対位置(値は固定) window.pageYOffsetはdocumentの上端からのスクロール量
//     //   console.log(sectionLinks)[index];
//     //   const absolutePositionTop =
//     //     sections[index].getBoundingClientRect().top + window.pageYOffset;
//     //   if (document.documentElement.scrollTop > absolutePositionTop) {
//     //     link.classList.add('inview');
//     //   } else {
//     //     link.classList.remove('inview');
//     //   }
//     // });
//   });
// }
// elevatorFunc();
